import {
  FETCH_COUNTRIES,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_FAILS,
} from './countryActionTypes';
import { FALLBACK_COUNTRIES } from '../../utils/country';

/**
 * `data` starts out as the bundled fallback so anything reading the registry has a usable list
 * from the first render. `resolved` says whether the fetch has settled either way.
 */
const initialState = {
  data: FALLBACK_COUNTRIES,
  fetching: false,
  resolved: false,
  usingFallback: true,
  error: null,
};

export const countryReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COUNTRIES:
      return { ...state, fetching: true, error: null };

    case FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        fetching: false,
        resolved: true,
        usingFallback: false,
        data: action.payload,
        error: null,
      };

    case FETCH_COUNTRIES_FAILS:
      return {
        ...state,
        fetching: false,
        resolved: true,
        usingFallback: true,
        data: action.payload.countries,
        error: action.payload.error,
      };

    default:
      return state;
  }
};

export default countryReducer;
